import { Components } from "appworks/components/components";
import { Contract } from "appworks/utils/contracts/contract";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";

/** @deprecated Move to class function */
export function JumpstartSpinCommand(): Contract<void> {
    return Components.get(AbstractMatrixComponent).startTransition(true);
}
